export default "__VITE_ASSET__Cv06Iwew__"